import Vue from 'vue'
import service from '../services/dashboard-service'

export function useDashboard() {
  const state = Vue.observable({
    loading: false
  })

  async function getDashboardStatus(params = {}) {
    state.loading = true
    try {
      const response = await service.getDashboardStatus(params)  
      state.loading = false
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function getDashboardVendors(params = {}) {
    state.loading = true
    try {
      const response = await service.getDashboardVendors(params)  
      state.loading = false
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function getDashboardRequestMonth(params = {}) {
    state.loading = true
    try {
      const response = await service.getDashboardRequestMonth(params)  
      state.loading = false
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function getDashboardVendorRequest(params = {}) {
    state.loading = true
    try {
      const response = await service.getDashboardVendorRequest(params)  
      state.loading = false
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  return { state, getDashboardStatus, getDashboardVendors ,getDashboardRequestMonth,getDashboardVendorRequest }
}
